import { render, staticRenderFns } from "./UpdateSerial.vue?vue&type=template&id=c1c2b914"
import script from "./UpdateSerial.vue?vue&type=script&lang=js"
export * from "./UpdateSerial.vue?vue&type=script&lang=js"
import style0 from "./UpdateSerial.vue?vue&type=style&index=0&id=c1c2b914&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports